import { call, put, takeLatest } from 'redux-saga/effects'
import { getDisclaimers } from '../api'
import { DISCLAIMERS_FETCH_REQUESTED } from '../constants'
import { disclaimersFetchFailed, disclaimersFetchSucceeded } from '../actions/disclaimer'

export function* fetchDisclaimers(action = null) {
  try {
    const response = yield call(getDisclaimers)
    yield put(disclaimersFetchSucceeded(response.data))
  } catch (error) {
    yield put(disclaimersFetchFailed(error))
  }
}

export function* watchDisclaimersFetchRequested() {
  yield takeLatest(DISCLAIMERS_FETCH_REQUESTED, fetchDisclaimers)
}
